var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.439 12.732l8.443-8.423c.312-.311.378-.797.168-1.186l-.208-.388-.384-.204a.99.99 0 0 0-1.164.172l-8.442 8.443-1.057 2.643 2.644-1.057zM15.57.416a.997.997 0 0 1-.277.889L13.93 2.649c.409.76.297 1.73-.343 2.368L5 13.584l-5 2 2-5 8.587-8.588a1.99 1.99 0 0 1 2.34-.348l1.365-1.36c.241-.24.577-.33.888-.27l.391.398zM9.646 3.354l.708-.708 3.292 3.293a1.5 1.5 0 0 1 0 2.122l-3.292 3.293-.708-.708 3.293-3.292a.5.5 0 0 0 0-.708L9.646 3.354z", fill: "#000", fillRule: "evenodd" })
  );
});